// extracted by mini-css-extract-plugin
export default {"ConnectionStatusBanner":"ConnectionStatusBanner_ConnectionStatusBanner__sWtta"};